import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { GaugeChartComponent } from '@recruitee/charts';
import { TranslatePipe } from '@recruitee/i18n';
import { TimeAgoAsyncPipe } from '@recruitee/user-interface';

@Component({
  selector: 'rt-interview-results-summary-chart',
  imports: [TranslatePipe, TimeAgoAsyncPipe, GaugeChartComponent],
  templateUrl: './interview-results-summary-chart.component.html',
  styleUrls: ['./interview-results-summary-chart.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterviewResultsSummaryChartComponent {
  @Input() public positiveRatings: number;
  @Input() public evaluationTranslationKey: string = 'app.interview.average_score';
  @Input() public totalRatings: number;
  @Input() public uniqAdmins: number;
  @Input() public lastUpdate: string | null = null;
}
